import React, { Component } from 'react';
import Container from "../../components/container/container-component";
import {connect} from "react-redux";
import {addTaxonomyRequest, inputChange, resetForm} from "./add-taxonomy-action-creators";
import Button from "../../components/button/button-component";
import Input from "../../components/input/input-component";
import {withRouter} from "react-router-dom";

class AddTaxonomy extends Component {

  componentWillUnmount() {
    this.props.resetForm()
  }


  render() {

    const {
      addTaxonomy,
      inputChange,
      id,
      loading
    } = this.props;

    return (
      <Container
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        <h2>Add taxonomy</h2>
        <form className="add_report_form" onSubmit={e => {
          e.preventDefault();
          addTaxonomy()
        }}>
          <Input
            name="ID"
            type="text"
            value={id.value}
            error={id.error}
            inputChange={e => inputChange({ inputValue: e.target.value, inputName: 'id'})}
          />
          <div className="add_report_form__button_wrapper">
            <Button
              name="Add Taxonomy"
              primaryBtn
              async
              loading={loading}
              width="40%"
              height="100%"
              type="submit"
              spinnerRight="12px"
              spinnerTop="15px"
            />
          </div>
        </form>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  id: state.addTaxonomy.id,
  loading: state.addTaxonomy.loading
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  addTaxonomy: () => dispatch(addTaxonomyRequest(ownProps.history)),
  inputChange: ({ inputName, inputValue }) => dispatch(inputChange({ inputName, inputValue })),
  resetForm: () => dispatch(resetForm())
});



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddTaxonomy));


// WEBPACK FOOTER //
// ./src/modules/add-taxonomy/add-taxonomy-component.js